/* global axios */
import ApiClient from '../ApiClient';

class AiBotStatsAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/stats`, { accountScoped: true });
  }

  // timezone_offset buckets the daily bot-vs-CS report in the viewer's day.
  get({ period } = {}) {
    return axios.get(this.url, {
      params: { period, timezone_offset: -new Date().getTimezoneOffset() / 60 },
    });
  }
}

export default AiBotStatsAPI;
